import { render, staticRenderFns } from "./Technicians.vue?vue&type=template&id=3986d31b&scoped=true&"
import script from "./Technicians.vue?vue&type=script&lang=js&"
export * from "./Technicians.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986d31b",
  null
  
)

export default component.exports